module.exports = __webpack_public_path__ + "img/checkout-notsuccessfull.e0fff94.webp";